<template>
    <LinkCard :blok="blok"></LinkCard>
</template>

<script setup lang="ts">
import type { ILinkCard } from '~ui/types/components/LinkCard';
import LinkCard from '~ui/components/Cards/LinkCard.vue';

defineProps<{ blok: ILinkCard }>();
</script>
